module.exports = {
	"root": "findify-layouts--search",
	"content": "findify-layouts--search__content"
};